<div id="institutional-dev-plan" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Institutional Development Plan</h2>
    <p class="inner-lead mt-3">
      The Institutional Development Plan (IDP) outlines the strategic vision, goals and action plans of Shah Satnam Ji
      Girls' College, Sirsa for holistic development. It encompasses academic, infrastructural, faculty and student
      development initiatives aimed at achieving excellence.
    </p>

    <hr class="divider">

    <div class="pdf-block">
      <pdf-viewer src="/assets/pdf/hei/inst-development-New.pdf" [render-text]="true" [original-size]="false"
        style="width:100%; height:680px; display:block;">
      </pdf-viewer>
    </div>

    <div class="mt-3">
      <a href="/assets/pdf/hei/inst-development-New.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-download"></i> Download Institutional Development Plan
      </a>
    </div>

  </div>
</div>